package com.arena_web.data.api

import com.arena_web.data.dto.FollowCountsDto
import com.arena_web.data.dto.FollowRelationDto
import com.arena_web.data.dto.FollowUserPageDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiDelete
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPost
import io.ktor.client.*

class FollowApi(private val client: HttpClient) {

    suspend fun followUser(userId: String): ApiResponse<Unit> =
        client.apiPost("v1/follow/$userId", Unit)

    suspend fun unfollowUser(userId: String): ApiResponse<Unit> =
        client.apiDelete("v1/follow/$userId")

    /** Remove someone from MY followers list (kick a follower). */
    suspend fun removeFollower(userId: String): ApiResponse<Unit> =
        client.apiDelete("v1/follow/followers/$userId")

    suspend fun getMyFollowers(params: Map<String, String> = emptyMap()): ApiResponse<FollowUserPageDto> =
        client.apiGet("v1/follow/me/followers", params)

    suspend fun getMyFollowing(params: Map<String, String> = emptyMap()): ApiResponse<FollowUserPageDto> =
        client.apiGet("v1/follow/me/following", params)

    suspend fun getFollowers(
        userId: String,
        params: Map<String, String> = emptyMap(),
    ): ApiResponse<FollowUserPageDto> =
        client.apiGet("v1/follow/users/$userId/followers", params)

    suspend fun getFollowing(
        userId: String,
        params: Map<String, String> = emptyMap(),
    ): ApiResponse<FollowUserPageDto> =
        client.apiGet("v1/follow/users/$userId/following", params)

    suspend fun getCounts(userId: String): ApiResponse<FollowCountsDto> =
        client.apiGet("v1/follow/users/$userId/counts")

    suspend fun getRelation(userId: String): ApiResponse<FollowRelationDto> =
        client.apiGet("v1/follow/users/$userId/relation")
}
